export default __webpack_public_path__ + "static/media/assetHeaderRight.b7f3a1a0.PNG";